import { ReactElement } from 'react';
import UsersPopup from '../reusable/UsersPopup';

interface IProps {
  onClose: () => void;
}

const ActiveUsers = ({ onClose }: IProps): ReactElement => (
  <UsersPopup onClose={onClose} isActive title="Active Users" />
);

export default ActiveUsers;
